import React from "react";
import throttle from "lodash.throttle";

import Button from "components/button/button";
import Link from "components/link/link";

import "./aboutNavigation.css";
import "./aboutNavigation-mobile.css";

class AboutNavigation extends React.Component {
  constructor(props) {
    super(props);

    this.aboutNavigationRef = React.createRef();
    this.buttonForPadding = React.createRef();

    this.state = {
      fixed: false
    };

    this.handleScroll = this.handleScroll.bind(this);
    this.throttledHandleScroll = throttle(this.handleScroll, 16);
  }

  componentDidMount() {
    window.addEventListener("scroll", this.throttledHandleScroll);
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.throttledHandleScroll);
  }

  handleScroll() {
    if (
      this.aboutNavigationRef.current !== null &&
      this.aboutNavigationRef.current.getBoundingClientRect().top < 15
    ) {
      this.setState({ fixed: true });
    } else {
      this.setState({ fixed: false });
    }
  }

  render() {
    return (
      <div
        className={`aboutNavigationContainer ${
          this.state.fixed === true ? "fixed" : ""
        }`}
        ref={this.aboutNavigationRef}
      >
        <div className="aboutNavigation placeholderNavContainer">
          <div className="buttonForPadding">
            <Button color="green" to="/products">
              <p>Shop</p>
            </Button>
          </div>
          <div className="navigationItems">
            <Link
              className={`navigationItem ${
                this.props.active === "About Us" ? "active" : ""
              }`}
              to="/about"
            >
              <div className="button">
                <p>About Us</p>
              </div>
            </Link>
            <Link
              className={`navigationItem ${
                this.props.active === "Sustainability" ? "active" : ""
              }`}
              to="/about/sustainability"
            >
              <div className="button">
                <p>Sustainability</p>
              </div>
            </Link>
            <Link
              className={`navigationItem ${
                this.props.active === "Ordering Info" ? "active" : ""
              }`}
              to="/about/orderinginfo"
            >
              <div className="button">
                <p>Ordering Info</p>
              </div>
            </Link>
            <Link
              className={`navigationItem ${
                this.props.active === "Press" ? "active" : ""
              }`}
              to="/about/press"
            >
              <div className="button">
                <p>Press</p>
              </div>
            </Link>
            <Link
              className={`navigationItem ${
                this.props.active === "Contact" ? "active" : ""
              }`}
              to="/about/contact"
            >
              <div className="button">
                <p>Contact</p>
              </div>
            </Link>
            <Link
              className={`navigationItem ${
                this.props.active === "Terms" ? "active" : ""
              }`}
              to="/about/terms"
            >
              <div className="button">
                <p>Terms</p>
              </div>
            </Link>
          </div>
        </div>
        <div className="aboutNavigation">
          <div className="buttonForPadding" ref={this.buttonForPadding}>
            <Button color="green" to="/products">
              <p>Shop</p>
            </Button>
          </div>
          <div className="navigationItems">
            <Link
              className={`navigationItem ${
                this.props.active === "About Us" ? "active" : ""
              }`}
              to="/about"
            >
              <div className="button">
                <p>About Us</p>
              </div>
            </Link>
            <Link
              className={`navigationItem ${
                this.props.active === "Sustainability" ? "active" : ""
              }`}
              to="/about/sustainability"
            >
              <div className="button">
                <p>Sustainability</p>
              </div>
            </Link>
            <Link
              className={`navigationItem ${
                this.props.active === "Ordering Info" ? "active" : ""
              }`}
              to="/about/orderinginfo"
            >
              <div className="button">
                <p>Ordering Info</p>
              </div>
            </Link>
            <Link
              className={`navigationItem ${
                this.props.active === "Press" ? "active" : ""
              }`}
              to="/about/press"
            >
              <div className="button">
                <p>Press</p>
              </div>
            </Link>
            <Link
              className={`navigationItem ${
                this.props.active === "Contact" ? "active" : ""
              }`}
              to="/about/contact"
            >
              <div className="button">
                <p>Contact</p>
              </div>
            </Link>
            <Link
              className={`navigationItem ${
                this.props.active === "Terms" ? "active" : ""
              }`}
              to="/about/terms"
            >
              <div className="button">
                <p>Terms</p>
              </div>
            </Link>
          </div>
        </div>
      </div>
    );
  }
}
export default AboutNavigation;
